/**
 * BuildingsPanel — Liste détaillée des immeubles dans la Vue portail.
 *
 * Extrait de AdminImmeublePortalMirror.jsx (Batch #14.221).
 */
import { Building2, MapPin, Pencil, Plus } from "lucide-react";
import { PanelTitle, EmptyState } from "./_shared";

// Panneaux de détails
// ════════════════════════════════════════════════════════════════════════════

function BuildingsPanel({ buildings, onEdit, onCreate }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3 gap-2">
        <PanelTitle icon={Building2} label="Immeubles" count={buildings.length} inline />
        {onCreate && (
          <button
            type="button"
            onClick={onCreate}
            className="text-[11px] px-2.5 py-1 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 inline-flex items-center gap-1 font-semibold shadow-sm"
            data-testid="mirror-building-create"
            title="Ajouter un immeuble au nom du client"
          >
            <Plus className="w-3 h-3" /> Ajouter un immeuble
          </button>
        )}
      </div>
      {buildings.length === 0 ? (
        <EmptyState label="Aucun immeuble enregistré." />
      ) : (
        <ul className="space-y-2">
          {buildings.map((b) => (
            <li key={b.id} className="flex items-start gap-3 p-2.5 rounded-lg border border-indigo-100 bg-indigo-50/40"
                data-testid={`mirror-building-${b.id}`}>
              <div className="w-9 h-9 rounded-lg bg-indigo-100 text-indigo-700 flex items-center justify-center flex-shrink-0">
                <Building2 className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm text-slate-800">{b.name || "Immeuble sans nom"}</div>
                <div className="text-[11px] text-slate-500 flex items-center gap-1 mt-0.5">
                  <MapPin className="w-3 h-3 flex-shrink-0" />
                  {[b.address_line, b.city, b.province, b.postal_code].filter(Boolean).join(", ") || "Adresse non renseignée"}
                </div>
              </div>
              {onEdit && (
                <button
                  type="button"
                  onClick={() => onEdit(b)}
                  className="text-[10px] px-2 py-1 rounded border bg-white border-indigo-300 text-indigo-700 hover:bg-indigo-50 inline-flex items-center gap-1 flex-shrink-0"
                  title="Modifier cet immeuble"
                  data-testid={`mirror-building-edit-${b.id}`}
                >
                  <Pencil className="w-3 h-3" /> Modifier
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export { BuildingsPanel };
